import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Typography,
  Container,
  CardContent,
  Card,
  Grid,
  Button,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import {
  apiEndpoints,
  apiGetRequest,
  apiDownloadFileData,
} from "src/utils/api/api";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { DateTimePicker } from "@material-ui/pickers";
import fileDownload from "js-file-download";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const RowButtons = (row) => {

  return (
    <Box>
      <Tooltip title="Edytuj">
        <IconButton
          aria-label="edytuj"
          component={RouterLink}
          to={`/administracja/slowniki/edytujinst/${row.id}`}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const EventLog = ({ enableGlobalLoader, disableGlobalLoader }) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [eventMinDate, setEventMinDate] = useState(null);
  const [eventMaxDate, setEventMaxDate] = useState(null);

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getEventLog.path, true)
      .then((data) => {
        disableGlobalLoader();
        setRows(data);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const headCells = [
    {
      id: "eventUser",
      numeric: false,
      disablePadding: true,
      fieldName: "eventUser",
      sortable: true,
      main: true,
      label: "Login użytkownika",
    },
    {
      id: "eventDate",
      fieldName: "eventDate",
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Data/czas zdarzenia",
    },
    {
      id: "eventDesc",
      fieldName: "eventDesc",
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Opis zdarzenia",
    },
  ];

  const handleEventMinDateChange = (date) => {
    setEventMinDate(date);
  };

  const handleEventMaxDateChange = (date) => {
    setEventMaxDate(date);
  };

  const handleExport = () => {
    enableGlobalLoader();
    apiDownloadFileData(`${apiEndpoints.getEventLogExcel.path}`, true)
      .then((result) => {
        disableGlobalLoader();
        fileDownload(result, "Zarejestrowane zdarzenia.xls");
      })
      .catch((error) => {
        disableGlobalLoader();
      });
  };

  return (
    <Page
      className={classes.root}
      title="Administracja - Monitorowanie zdarzeń"
    >
      <KmPageTitle>
        Monitorowanie zdarzeń
      </KmPageTitle>
      <Container maxWidth={false}>
        {/* <Toolbar dialogHandler={handleClickOpen} /> */}

        <Box display="flex" justifyContent="flex-end">
          <Button
            color="secondary"
            variant="contained"
            onClick={handleExport}
            className={classes.toolbarLeftButton}
          >
            Eksport zdarzeń
          </Button>
        </Box>

        <Box mt={3}>
          <Box mt={1} mb={1}>
            <Card>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} sm={6}>
                    <DateTimePicker
                      clearable
                      autoOk
                      ampm={false}
                      id="eventmindate"
                      fullWidth
                      label="Data minimalna"
                      clearable
                      value={eventMinDate}
                      placeholder="Data minimalna"
                      onChange={(date) => handleEventMinDateChange(date)}
                      format="DD/MM/yyyy HH:mm"
                      animateYearScrolling
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} sm={6}>
                    <DateTimePicker
                      clearable
                      autoOk
                      ampm={false}
                      id="eventmaxdate"
                      fullWidth
                      label="Data maksymalna"
                      clearable
                      value={eventMaxDate}
                      placeholder="Data maksymalna"
                      onChange={(date) => handleEventMaxDateChange(date)}
                      format="DD/MM/yyyy HH:mm"
                      animateYearScrolling
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
          <KmFilteredTable markable={false} headCells={headCells} rows={rows} />
          {/* <Dialog
        fullScreen={fullScreen}
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Usuwanie isntytucji"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Czy na na pewno chcesz usunąć zaznaczone elementy?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Nie
          </Button>
          <Button onClick={handleDelete} color="primary" autoFocus>
            Tak
          </Button>
        </DialogActions>
      </Dialog> */}
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(EventLog);
